import posthog from 'posthog-js'

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string) || 'https://us.i.posthog.com'

export function initPostHog() {
  if (!POSTHOG_KEY) return
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    // Page & interaction tracking
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
    persistence: 'localStorage+cookie',

    // Session replay — 5K recordings/month on free tier
    enable_recording_console_log: false,
    session_recording: {
      // Mask all text inputs by default for privacy (emails, codes, etc.)
      maskAllInputs: true,
    },

    // Performance — capture web vitals (LCP, FID, CLS)
    capture_performance: true,

    // Don't track admin/dev traffic
    opt_out_capturing_by_default: false,
    loaded: (ph) => {
      // Disable tracking in development to save quota
      if (import.meta.env.DEV) {
        ph.opt_out_capturing()
      }
    },
  })
}

export function identifyUser(clerkId: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.identify(clerkId, properties)
}

/** Update user properties without creating a new event */
export function setUserProperties(properties: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.people.set(properties)
}

/** Track a custom event — use sparingly to stay within free tier limits */
export function trackEvent(event: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.capture(event, properties)
}

/**
 * Associate the current person with a group (e.g. a household) so PostHog can
 * report engagement at the household/cohort level, not just per user.
 */
export function groupUser(groupType: string, groupKey: string, properties?: Record<string, unknown>) {
  if (!POSTHOG_KEY) return
  posthog.group(groupType, groupKey, properties)
}

export function resetPostHog() {
  if (!POSTHOG_KEY) return
  posthog.reset()
}

export { posthog }
